<template>
  <SvgIcon
    :name="getSvgIcon"
    :size="size"
    v-bind="$attrs"
    v-on="$listeners"
    :class="[$attrs.class]"
    :color="color"
    v-if="isSvgIcon"
  ></SvgIcon>
  <span v-on="$listeners" :class="[name ? `el-icon-${name}` : '', $attrs.class]" v-else></span>
</template>

<script>
import SvgIcon from './SvgIcon.vue'

const SVG_END_WITH_FLAG = '|svg'

export default {
  name: 'AkeIcon',

  components: {
    SvgIcon,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    // width: {
    //   type: [Number, String],
    // },
    // height: {
    //   type: [Number, String],
    // },
    color: String,
  },

  computed: {
    isSvgIcon() {
      return this.name && this.name.endsWith(SVG_END_WITH_FLAG)
    },
    getSvgIcon() {
      return this.name.replace(SVG_END_WITH_FLAG, '')
    },
  },
}
</script>

<style lang="scss" scoped></style>
